// eslint-disable-next-line import/no-cycle
import { baseAd, baseBs, BS_YEAR_MONTH_DAYS } from './constants';

// export type EachBSYear = keyof typeof BS_YEAR_MONTH_DAYS;

/**
 * Stores how many days has passed from the beginning in each year object
 */
export const cache = {
  getCumulativeTotal: (() => {
    const memo = {};

    return () => {
      if (Object.prototype.hasOwnProperty.call(memo, 'result')) {
        return memo.result;
      }

      const years = Object.keys(BS_YEAR_MONTH_DAYS) || [];

      const startingYear = +(years[0] || 0);
      const totalYears = years.length;
      const obj = {};

      for (let i = 0; i < totalYears; i += 1) {
        const yearIndex = startingYear + i;

        const prevYearIndex = obj[yearIndex - 1];
        const currYearIndex = BS_YEAR_MONTH_DAYS[yearIndex].slice(-1)[0];

        obj[yearIndex] = (i === 0 ? 0 : prevYearIndex || 0) + (currYearIndex || 0);
      }

      memo.result = obj;
      return obj;
    };
  })(),
};

/**
 * Returns the Index of week  0 for sunday and so on..
 * @param {number} daysCount - No. of days from the base bs
 */
const getDayIndex = (daysCount) => ((daysCount % 7) + baseBs.dayOfWeek) % 7;

/**
 * Returns the number of days from the base_bs day
 * @param {Date} date - AD date in the format
 */
const countBSDaysFromBaseDateUsingAdDate = (year, month, day) => {
  const dateObj = { year, month: month - 1, day };

  const date1 = new Date(baseAd.year, baseAd.month, baseAd.day);
  const date2 = new Date(dateObj.year, dateObj.month, dateObj.day);

  const timeDiff = date2.getTime() - date1.getTime();

  const dayCount = Math.ceil(timeDiff / (1000 * 3600 * 24));

  return dayCount;
};

/**
 * Convert AD To BS date
 */
export const ad2bs = (years, months, date) => {
  const dayCount = countBSDaysFromBaseDateUsingAdDate(years, months, date);

  const cumulativeData = cache.getCumulativeTotal();

  if (!cumulativeData) {
    throw new Error("The date doesn't fall within 1975/01/01 - 2092/12/30");
  }

  const values = Object.values(cumulativeData);
  const yearIndex = values.findIndex((value) => (value) >= dayCount);

  let year = +baseBs.year + yearIndex;
  const offsetCumulativeYear = cumulativeData[year - 1];

  if (!offsetCumulativeYear) {
    throw new Error('Internal Error: Constant object is empty or missing something');
  }

  let offsetDays = yearIndex === 0 ? dayCount : dayCount - offsetCumulativeYear;
  let month = 0;

  const offsetCumulativeMonth = BS_YEAR_MONTH_DAYS[year][month];
  if (!offsetCumulativeMonth) {
    throw new Error('Internal Error: Constant object is empty or missing something');
  }

  while (offsetCumulativeMonth <= offsetDays) {
    // check
    offsetDays -= offsetCumulativeMonth;
    month += 1;
  }
  if (+month === 12) {
    month = 0;
    year += 1;
  }

  return {
    year,
    month: month + 1, // 1 for Baisakh
    day: offsetDays + 1,
    dayOfWeek: getDayIndex(dayCount),
  };
};

/**
 * Convert BS To AD date
 */
export const bs2ad = (year, month, day) => {
  const cumulativeData = cache.getCumulativeTotal();

  if (!cumulativeData) {
    throw new Error("The date doesn't fall within 1975/01/01 - 2092/12/30");
  }

  let prevMonthCumulativeTotal = 0;
  const prevYearCumulativeTotal = cumulativeData[+year - 1] || 0;

  for (let i = 0; i < +month - 1; i += 1) {
    const currentCumulativeTotal = BS_YEAR_MONTH_DAYS[+year][i];

    if (!currentCumulativeTotal) {
      throw new Error('Internal Error: Constant object is empty or missing something');
    }

    prevMonthCumulativeTotal += currentCumulativeTotal;
  }

  const countDays = prevYearCumulativeTotal + prevMonthCumulativeTotal + +day - 1;

  const date1 = new Date(baseAd.year, baseAd.month, baseAd.day);
  date1.setDate(date1.getDate() + countDays);

  return {
    year: date1.getFullYear(),
    month: date1.getMonth() + 1,
    day: date1.getDate(),
    dayOfWeek: date1.getDay(),
  };
};

/**
 * Get Days is the given month and year
 */
export const getBSMonthDays = (month, year) => BS_YEAR_MONTH_DAYS[year]?.[month - 1];

/**
 * Get Days is the given month and year
 */
export const getStartingDayOfBsMonth = (year, month) => {
  const monthIndex = month - 1;
  const cumulativeData = cache.getCumulativeTotal();

  if (!cumulativeData) {
    throw new Error("The date doesn't fall within 1975/01/01 - 2092/12/30");
  }

  const prevYearTotal = cumulativeData[year - 1] || 0;
  let days = 0;
  for (let i = 0; i < monthIndex; i += 1) {
    const currentCumulativeTotal = BS_YEAR_MONTH_DAYS[+year][i];

    if (!currentCumulativeTotal) {
      throw new Error('Internal Error: Constant object is empty or missing something');
    }

    days += currentCumulativeTotal;
  }
  const daysCount = prevYearTotal + days;
  return getDayIndex(daysCount);
};
